<template>
  <div class="m_merchants project_detail">
    <mt-header title="Exhibitor Favorites">
      <span slot="left" @click="()=>this.$router.back()">
        <i class="iconfont icon-left"></i>
        Return
      </span>
    </mt-header>
    <div class="m_content">
      <ul
        v-show="zsList.list.length>0"
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="false"
        infinite-scroll-distance="1"
        :infinite-scroll-immediate-check="false"
        >
        <li class="liItemL" v-for="(item,index) in zsList.list" :key="index" @click="$router.push('/exhibitor/details/'+item.offid+'/'+item.ocid)">
          <div class="liLeft">
            <img :src="item.corplogo_cn" alt=""/>
          </div>
          <div class="liRight">
            <h6>{{item.corpname_en}}</h6>
            <p>Booth No：{{item.booth}}</p>
            <p>Booth Area：{{item.area}}m²</p>
          </div>
          <div class="quguan">
            <!-- 取消 -->
            <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/like_1.png" @click.stop="cancel(item.ocid)" />
          </div>
        </li>
        <li class="more_loading" >
          <span v-show="zsList.list.length<zsList.listnum">
          <!-- <span > -->
            <div class="m_upload">
              <mt-spinner type="snake" color="#00ccff" :size="20" ></mt-spinner>
              <span>Loading...</span>
            </div>
          </span>
          <span v-show="zsList.list.length>=zsList.listnum" class="over">Final Page</span>
        </li>
      </ul>
      <div v-show="zsList.list.length<=0" class="zanwu">
        <div><img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/without.png" alt=""/></div>
        <p class="p">No data is available!</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Header } from 'mint-ui';
import { reqMyCorpColl, reqCorpCollDo } from "../../../../api";
export default {
  components:{
    'mt-header':Header
  },
  data(){
    return{
      zsList:{list:[],listnum:99,pagelistnum:0,thispage:0},
    }
  },
  mounted(){
    // this.exhibitorList()
  },
  methods:{
    // 懒加载
    async loadMore() {
      if (this.zsList.thispage*this.zsList.pagelistnum*1>=this.zsList.listnum*1) {
        return
      }
      this.exhibitorList(this.zsList.thispage*1+1)
      // console.log(1111);

    },
    // 展商收藏列表请求
    async exhibitorList(page=1){
      const response = await reqMyCorpColl(page)
      if(response.code*1==2){
          this.zsList.list.push(...response.reslist)
          this.zsList.thispage=response.thispage
          this.zsList.listnum=response.listnum
          this.zsList.pagelistnum=response.pagelistnum
        // console.log(response);
      }else{
          this.zsList={
            list:[],
            listnum:0,
            pagelistnum:0,
            thispage:0
          }
        }
      // console.log(this.zsList.list);
    },
    async cancel(ocid){//取消收藏
      const response = await reqCorpCollDo(ocid)
      if (response.code==0) {
        this.zsList={
          list:[],
          listnum:0,
          pagelistnum:0,
          thispage:0
        }
        this.exhibitorList()
        // this.success(this,'Cancel Successfully！')
      }else{
        // this.err(this,'Timeout, please try')
      }
    },
  }
}
</script>

<style scoped>
.m_merchants{
  height: 100%;
}
.m_content{
    height: calc(100% - 30px);
    overflow-y: auto;
    padding: 0 10px;
}
.liItemL{
  width: 100%;
  height: 100px;
  display: flex;
  /* padding: 10px 0 10px 10px; */
  margin-top: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, .2);
  border-radius: 10px;
  overflow: hidden;
}
.liLeft{
  width: 24%;
  padding: 10px;
}
.liRight{
  padding: 20px 0;
  width: 60%;
  line-height: 20px;
}
.quguan{
  /* width: 16%; */
  width: 20px;
  margin: auto;
  /* background-color: #ff840c; */
  color: white;
  font-size: 14px;
  text-align: center;
  /* line-height: 100px; */
}

/* 空 */
.zanwu{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -70%);
  width: 240px;
  text-align: center;
}
</style>